export default class IRScroll {
    constructor() {
        this.init();
    }

    init() {
        if (!window.jQuery) {
            return;
        }
        var ir = $('.irScroll');
        if (!ir || ir.length == 0) {
            return;
        }

        var irHTML = $(ir).html();
        var initWidth = $(ir).width();

        if (initWidth > 478) {
            var duplicateContentTimes = Math.round(initWidth / 478);

            for (var i = 0; i < duplicateContentTimes; i++) {
                $(ir).append(irHTML);

                //init marquee when the last append comes
                if (i == duplicateContentTimes - 1) {
                    createMarquee($(ir));

                    //reinit marquee on resize
                    $(window).resize(function () {
                        initWidth = $(ir).width();
                        $(ir).marquee('destroy');
                        createMarquee($(ir));
                    });
                }
            }

        } else {
            createMarquee($(ir));
        }

        function createMarquee(element) {
            element.marquee({
                duration: 25000,
                duplicated: true,
                pauseOnHover: true,
                delayBeforeStart: 0
            });
        }

    }

}
